var _jsxFileName = "/codebuild/output/src476694551/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/steps/RegisterMinorAccountIntro.tsx";
import React from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
import { ContentContainer } from '../helpers';
function RegisterMinorAccountIntro() {
  const appName = i18n.t('Global.appNames.libreView');
  return /*#__PURE__*/React.createElement(ContentContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    flexDirection: "column",
    alignItems: "center",
    paddingHorizontal: "$4",
    marginTop: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("img", {
    id: "CreateAccountIntro-image-of-family",
    src: i18n.t('CreateAccountIntro.content.createAccountIntro.media.introMinor'),
    alt: "a family with the father hugging the mom and the daughter in the middle of them",
    style: {
      maxWidth: '100vw',
      height: '260px',
      objectFit: 'contain',
      margin: '12px auto 20px auto'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    flexDirection: "column",
    gap: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    type: "$bodyBase.medium",
    color: "$text.100",
    testID: "CreateAccountIntro.content.createAccountIntro.primaryText",
    nativeID: "CreateAccountIntro.content.createAccountIntro.primaryText",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 11
    }
  }, i18n.t('CreateAccountIntro.content.createAccountIntro.primaryText')), /*#__PURE__*/React.createElement(Text, {
    type: "$bodyBase.medium",
    color: "$text.100",
    testID: "CreateAccountIntro.content.createAccountIntro.bodyText",
    nativeID: "CreateAccountIntro.content.createAccountIntro.bodyText",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 11
    }
  }, i18n.t('CreateAccountIntro.content.createAccountIntro.bodyText', {
    appName
  })))));
}
export { RegisterMinorAccountIntro };